import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import {mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState} from "../../../consumers/httpRequiestsUtils";
import {GENERIC_SUCCESS_TOAST_MESSAGE,TIPO_PRESTAMO_IDS_MOTIVO,TIPO_PRESTAMO_IDS_CUOTAS,TIPO_PRESTAMO_IDS_MESGRATI,TIPO_PRESTAMO_IDS_SIN_SUSTENTO
    ,ID_SOLICITUD_TIPO_PRESTAMO
    ,ID_SOLICITUD_TIPO_ADELANTO_SUELDO
    } from "../../../constants/hardCodedConstants";
import GenericModal from '../../../components/modal/GenericModal';
import SelectInput from "../../../components/Select/SelectInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useGetRequest} from "../../../hooks/useGetRequest/useGetRequest";
import {usePostRequest} from "../../../hooks/usePostRequest/usePostRequest";
import {
    isEmpty,
    mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric,
    formatearMesPreview,
    calcularMesFinPreview
} from "../../../helper/utils";
import {buscarColaboradorPrestamoAPI, getAllTipoSolicitudPrestamoAPI
    , getAllTipoMotivosPrestamoAPI, crearSolicitudPrestamoAPI, getMaxCuotaPrestamoAPI, downloadSolicitudPrestamoAPI, getMesGratificacionPermitidoAPI
    , getMiSueldoAPI, getSueldoColaboradorAPI } from "../../../consumers/backendApisUrls";
import GenericUploadFileV2 from "../../../components/GenericUploadFile/GenericUploadFileV2";
import {AlertErrorMaxFileSizePrestamos} from "../alerts/AlertErrorMaxFileSizePrestamos";
import InputBool from '../../../components/modalComponents/InputBool';
import { grey } from '@material-ui/core/colors';


// Texto centinela que devuelve el backend cuando no hay campaña de gratificación vigente
// para la fecha actual (ver GetMesGratificacionPermitido).
const SIN_CAMPANA_GRATIFICACION_ACTIVA = "no aplica";

const SolicitarPrestamo = ({ showModal, refreshPage, fromAdminPage = false, esGestorPrestamos = false }) => {
    const sectionName = "RegistrarPrestamoModal";
    const [formValues, setFormValues] = useState({});
    const [checkFirma, setCheckFirma]           = useState(false);
    const [checkDeclaracion, setCheckDeclaracion] = useState(false);
    //const [archivoNombre, setArchivoNombre]     = useState("");
    const [criterioDeBusqueda, setCriterioDeBusqueda] = useState("");
    const [cargandoColaboradores, setCargandoColaboradores] = useState(false);
    const [selectInputColaboresPlaceholder, setSelectInputColaboresPlaceholder] = useState("");
    const [colaboradoresFiltradosOptions, setColaboradoresFiltradosOptions] = useState([]);
    const [jsonSelectedColaboradorValue, setJsonSelectedColaboradorValue] = useState({});
    const [executeGetRequest] = useGetRequest();
    const [executePostRequest] = usePostRequest();
    const [tiposDePrestamoFiltradosOptions, setTiposDePrestamoFiltradosOptions] = useState([]);
    const [jsonSelectedTiposPrestamoValue, setJsonSelectedTiposPrestamoValue] = useState({});
    const [motivosDePrestamoFiltradosOptions, setMotivosDePrestamoFiltradosOptions] = useState([]);
    const [jsonSelectedMotivoPrestamoValue, setJsonSelectedMotivoPrestamoValue] = useState({});
    const [jsonTextAreaOtros, setJsonTextAreaOtros] = useState("");
    const [enviando, setEnviando] = useState(false);
    const [previsualizando, setPrevisualizando] = useState(false);
    const [maxCuota, setMaxCuota] = useState(10);
    const [mesInicioDescuentoPreview, setMesInicioDescuentoPreview] = useState(null);
    const [mesFinDescuentoPreview, setMesFinDescuentoPreview] = useState(null);
    const [documentoFirmado, setDocumentoFirmado] = useState({});
    const [mesGratificacionPermitido, setMesGratificacionPermitido] = useState("");
    const [sueldoEmpleado, setSueldoEmpleado] = useState("");

    const actualTipo = jsonSelectedTiposPrestamoValue?.Value;

    // Única fuente de verdad: el adelanto de gratificación sin restricción (70542) no lleva sustento.
    const requiereSustento = !TIPO_PRESTAMO_IDS_SIN_SUSTENTO.includes(Number(jsonSelectedTiposPrestamoValue?.Value));

    // const [s3UploadFileResponseFirma, setS3UploadFileResponseFirma] = useState({});
    // const [subiendoArchivoFirma, setSubiendoArchivoFirma] = useState(false);
    // const UPDATE_FILE_INPUT_ID = "addPrestamoModal-firma";
    
    // ── Archivo: firma (usuario final) ──────────────────────────────
    const [s3UploadFileResponseFirma, setS3UploadFileResponseFirma] = useState({});
    const [subiendoArchivoFirma, setSubiendoArchivoFirma] = useState(false);
    const UPDATE_FILE_FIRMA_ID = "addPrestamoModal-firma";

    // ── Archivo: documento de solicitud de préstamo (Gestor GDH) ────
    const [s3UploadFileResponseAutorizacion, setS3UploadFileResponseAutorizacion] = useState({});
    const [subiendoArchivoAutorizacion, setSubiendoArchivoAutorizacion] = useState(false);
    const UPDATE_FILE_AUTORIZACION_ID = "addPrestamoModal-autorizacion";

    // ── Archivo: documento sustento ──────────────────────────────────
    const [s3UploadFileResponseSustento, setS3UploadFileResponseSustento] = useState({});
    const [subiendoArchivoSustento, setSubiendoArchivoSustento] = useState(false);
    const UPDATE_FILE_SUSTENTO_ID = "addPrestamoModal-sustento";

    // Huella de los datos que se imprimen en el PDF firmado. Sirve para saber si el documento
    // generado (previsualización) sigue siendo válido para lo que se va a enviar.
    const [huellaDocumentoFirmado, setHuellaDocumentoFirmado] = useState("");
    const construirHuellaDocumento = () => JSON.stringify([
        jsonSelectedTiposPrestamoValue?.Value ?? null,
        formValues.Monto ?? null,
        formValues.NroCuotas ?? null,
        formValues.MesDsctoGratificacion ?? null,
        jsonSelectedMotivoPrestamoValue?.label ?? null,
        jsonTextAreaOtros ?? "",
        s3UploadFileResponseFirma?.Path ?? null,
    ]);
    const huellaActual = construirHuellaDocumento();

    // Si el tipo elegido no lleva sustento, descartar cualquier archivo subido antes con otro tipo.
    useEffect(() => {
        if (!requiereSustento) {
            setS3UploadFileResponseSustento({});
        }
    }, [requiereSustento]);

    // Si cambia cualquier dato del documento, el PDF previsualizado deja de ser válido.
    useEffect(() => {
        if (huellaDocumentoFirmado && huellaDocumentoFirmado !== huellaActual) {
            setDocumentoFirmado({});
            setHuellaDocumentoFirmado("");
        }
    }, [huellaActual]);


    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    useEffect(() => {
        if (mesInicioDescuentoPreview && formValues.NroCuotas && parseInt(formValues.NroCuotas) > 0) {
            const fin = calcularMesFinPreview(mesInicioDescuentoPreview, parseInt(formValues.NroCuotas));
            setMesFinDescuentoPreview(fin);
        } else {
            setMesFinDescuentoPreview(null);
        }
    }, [formValues.NroCuotas, mesInicioDescuentoPreview]);

    const init = async () => {

        // const responsePeriodo = await executeGetRequest(getEsPeriodoNoPermitidoAPI());
        // console.log("responsePeriodo: ", responsePeriodo.data)
        // if (responseCode200(responsePeriodo) && !responsePeriodo.data) {
        //     setTimeout(() => {
        //         toast.warn("No es posible registrar solicitudes en este período.");
        //         showModal();
        //     }, 100);
        //     return;
        // }

        let formInputValues = getInitialFormValues();
        setFormValues(formInputValues);
        let responseTipos = await executeGetRequest(getAllTipoSolicitudPrestamoAPI());
        if (responseCode200(responseTipos)) {
            let options = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric(responseTipos.data, "Value", "Text");
            setTiposDePrestamoFiltradosOptions(options);
        }else{
            mostrarMensajeDeErrorConToast(responseTipos);
        }

        let response = await executeGetRequest(getAllTipoMotivosPrestamoAPI());
        if (responseCode200(response)) {
            let options = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric(response.data, "Value", "Text");
            setMotivosDePrestamoFiltradosOptions(options);
        }else{
            mostrarMensajeDeErrorConToast(response);
        }

        let responseMaxCuota = await executeGetRequest(getMaxCuotaPrestamoAPI());
        if (responseCode200(responseMaxCuota)) {
            setMaxCuota(responseMaxCuota.data.CuotaMaxima);
            if (responseMaxCuota.data.MesInicioDescuento) {
                setMesInicioDescuentoPreview(responseMaxCuota.data.MesInicioDescuento);
            }
        }

        if (!fromAdminPage) {
            let responseSueldo = await executeGetRequest(getMiSueldoAPI());
            if (responseCode200(responseSueldo) && responseSueldo.data) {
                setSueldoEmpleado(responseSueldo.data);
            }
        }
    }

    const getInitialFormValues = () => ({        
        IdTipoSolicitud: null,
        Monto: null,
        NroCuotas: null,
        IdMotivoSolicitud: null,
        OtroMotivo: null,
        MesDsctoGratificacion: null,
        ComunicoAJefe: false,
        TieneExcepcion: false,
        MotivoExcepcion: "",
    })

   
    const handleKeypress = (e) => {
        if (e.key === 'Enter') {
            buscarColaborador();
        }
    };
    const buscarColaborador = async () => {
        console.debug("buscar colaborador: ", {criterioDeBusqueda});

        if (isEmpty(criterioDeBusqueda)) {
            toast.warn("Ingresar un criterio de búsqueda.");
            return;
        }

        setCargandoColaboradores(true);
        setSelectInputColaboresPlaceholder("");
        const payload = {
            "Criteria": criterioDeBusqueda
        }
        let response = await executePostRequest(buscarColaboradorPrestamoAPI(), payload);

        if (responseCode200(response)) {
            let options = (response.data ?? []).map((option) => ({value: option["Value"], label: option["Text"]}));
            setColaboradoresFiltradosOptions(options);
            setSelectInputColaboresPlaceholder("Seleccionar colaborador");
        } else {
            setColaboradoresFiltradosOptions([]);
            setSelectInputColaboresPlaceholder("");
            mostrarMensajeDeErrorConToast(response);
        }
        setCargandoColaboradores(false);
    };

    useEffect(()=>{
            setJsonTextAreaOtros("")
            setJsonSelectedMotivoPrestamoValue({})
            // Limpiar cuotas y meses si cambia el tipo de solicitud
            setFormValues(prev => ({ ...prev, NroCuotas: "", MesDsctoGratificacion: "" }));
        },[jsonSelectedTiposPrestamoValue])

    useEffect(() => {
        const tipo = jsonSelectedTiposPrestamoValue?.Value;
        if (TIPO_PRESTAMO_IDS_MESGRATI.includes(Number(tipo))) {
            (async () => {
                const response = await executeGetRequest(getMesGratificacionPermitidoAPI(tipo));
                if (responseCode200(response) && response.data) {
                    const sinCampanaActiva = String(response.data).trim().toLowerCase()
                        === SIN_CAMPANA_GRATIFICACION_ACTIVA;

                    // Un gestor de Préstamos y Adelantos registrando en modo administrador
                    // puede elegir manualmente el mes (Julio/Diciembre) aunque no haya una
                    // campaña vigente para la fecha actual. El backend de escritura ya omite
                    // la validación de período permitido cuando el registro es en modo admin.
                    if (sinCampanaActiva && fromAdminPage && esGestorPrestamos) {
                        setMesGratificacionPermitido("");
                        return;
                    }

                    setMesGratificacionPermitido(response.data);
                    return;
                }
                setMesGratificacionPermitido("");
            })();
        } else {
            setMesGratificacionPermitido("");
        }
    }, [jsonSelectedTiposPrestamoValue]);

    useEffect(() => {
        if (mesGratificacionPermitido) {
            setFormValues(prev => ({ ...prev, MesDsctoGratificacion: mesGratificacionPermitido }));
        }
    }, [mesGratificacionPermitido])

    useEffect(() => {
        if (fromAdminPage && jsonSelectedColaboradorValue?.value) {
            (async () => {
                let response = await executeGetRequest(getSueldoColaboradorAPI(jsonSelectedColaboradorValue.value));
                if (responseCode200(response) && response.data) {
                    setSueldoEmpleado(response.data);
                } else {
                    setSueldoEmpleado("");
                }
            })();
        }
    }, [jsonSelectedColaboradorValue])

    const handleEnviarSolicitud = async () => {
        if (fromAdminPage && esGestorPrestamos && !jsonSelectedColaboradorValue?.value) {
            toast.warn("Debe seleccionar un colaborador.");
            return;
        }

        if (!jsonSelectedTiposPrestamoValue?.Value) {
            toast.warn("Debe seleccionar un tipo de solicitud.");
            return;
        }

        if (isEmpty(formValues.Monto)) {
            toast.warn("Debe ingresar un monto.");
            return;
        }
        
        const tipoSolicitudActual = jsonSelectedTiposPrestamoValue?.Value;
        //console.log('Tipo: ' + tipoSolicitudActual);
        
        if (tipoSolicitudActual === ID_SOLICITUD_TIPO_PRESTAMO) {
            if (isEmpty(formValues.NroCuotas)) {
                toast.warn("Debe seleccionar el número de cuotas para este tipo de solicitud.");
                return;
            }
            //console.log('NroCuotas: ' + formValues.NroCuotas);
        }

        if (TIPO_PRESTAMO_IDS_MOTIVO.includes(Number(tipoSolicitudActual))) {
            if (!jsonSelectedMotivoPrestamoValue?.Value) {
                toast.warn("Debe seleccionar un motivo para este tipo de solicitud.");
                return;
            }

            // Validación extra: Si elige "Otros", el textarea no puede estar vacío
            const labelMotivo = jsonSelectedMotivoPrestamoValue?.label;
            if ((labelMotivo === "Otros" || labelMotivo === "Otro") && isEmpty(jsonTextAreaOtros)) {
                toast.warn("Debe especificar el motivo en el campo de texto.");
                return;
            }
        }

         if (TIPO_PRESTAMO_IDS_MESGRATI.includes(Number(tipoSolicitudActual))) {
            if (isEmpty(formValues.MesDsctoGratificacion)) {
                toast.warn("Debe seleccionar el mes de gratificación para este tipo de solicitud.");
                return;
            }
            if (formValues.MesDsctoGratificacion && !["Julio", "Diciembre"].includes(formValues.MesDsctoGratificacion)) {
                toast.warn("Actualmente no se encontró una campaña de adelanto de gratificación activa");
                return;
            }
            //console.log('MesDsctoGratificacion: ' + formValues.MesDsctoGratificacion);
         }

        // if (!s3UploadFileResponseFirma?.Path) {
        //     toast.warn("Debe adjuntar una imagen de su firma.");
        //     return;
        // }

        // ── Validación de archivo según contexto ───────────────────
        setEnviando(true);
        let pdfParaGuardar = null;
        if (fromAdminPage && esGestorPrestamos) {
            if (!s3UploadFileResponseAutorizacion?.Path) {
                toast.warn("Debe adjuntar el documento de solicitud de préstamo.");
                setEnviando(false);
                return;
            }
            if (requiereSustento && !s3UploadFileResponseSustento?.Path) {
                toast.warn("Debe adjuntar el documento de sustento.");
                setEnviando(false);
                return;
            }
        } else {
            if (!s3UploadFileResponseFirma?.Path) {
                toast.warn("Debe adjuntar una imagen de su firma.");
                setEnviando(false);
                return;
            }
            if (!checkFirma) {
                toast.warn("Debe aceptar el uso de su firma.");
                setEnviando(false);
                return;
            }
            if (requiereSustento && !s3UploadFileResponseSustento?.Path) {
                toast.warn("Debe adjuntar el documento de sustento.");
                setEnviando(false);
                return;
            }
        }

        if (!checkDeclaracion) {
            toast.warn("Debe aceptar la Declaración Jurada para continuar.");
            setEnviando(false);
            return;
        }

        if (formValues.TieneExcepcion && isEmpty(formValues.MotivoExcepcion)) {
            toast.warn("Debe ingresar el detalle de la excepción.");
            setEnviando(false);
            return;
        }

        if (!(fromAdminPage && esGestorPrestamos)) {
            // Preparar documento de solicitud con firma incluida (solo después de validar todo,
            // para no generar PDFs en S3 si el envío va a fallar). Se reutiliza el previsualizado
            // únicamente si fue generado con los mismos datos que se están enviando.
            const documentoVigente = documentoFirmado?.Path && huellaDocumentoFirmado === huellaActual;
            pdfParaGuardar = documentoVigente ? documentoFirmado : await obtenerFormatoFirmado();
            if (!pdfParaGuardar) {
                mostrarMensajeDeErrorConToast("No se pudo generar el documento con la firma. Intente nuevamente.");
                setEnviando(false);
                return;
            }
        }

        console.debug("handleEnviarSolicitud ", formValues)

        const fileViewModel = fromAdminPage && esGestorPrestamos
            ? s3UploadFileResponseAutorizacion
            : pdfParaGuardar;

        let payload = {
            "IdTipoSolicitud" : jsonSelectedTiposPrestamoValue?.Value,
            "IdMotivoSolicitud" : jsonSelectedMotivoPrestamoValue?.Value,
            //"IdEmpleado" : jsonSelectedColaboradorValue?.value,
            "IdEmpleado": fromAdminPage && esGestorPrestamos ? jsonSelectedColaboradorValue?.value : null,
            "OtroMotivo" : jsonTextAreaOtros,
            "Monto" : formValues.Monto,
            "NroCuotas" : formValues.NroCuotas,
            "MesDsctoGratificacion" : formValues.MesDsctoGratificacion,
            "ComunicoAJefe": formValues.ComunicoAJefe ?? false,
            "TieneExcepcion": formValues.TieneExcepcion ?? false,
            "MotivoExcepcion": formValues.TieneExcepcion ? formValues.MotivoExcepcion : null,
            "FileViewModel": fileViewModel,
            "FileViewModelSustento": requiereSustento && s3UploadFileResponseSustento?.Path ? s3UploadFileResponseSustento : null,
            "FileViewModelFirma": s3UploadFileResponseFirma?.Path ? s3UploadFileResponseFirma : null,
        }

        //setEnviando(true);
        try{
            let response = await executePostRequest(crearSolicitudPrestamoAPI(), payload);
            if (responseCode200(response)) {
                showModal();
                toast.success((response?.data?.Message) ? response?.data?.Message : GENERIC_SUCCESS_TOAST_MESSAGE);
                await refreshPage();
            } else if (responseTieneModelState(response)) {
                console.log("responseTieneModelState")
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        } finally{
            setEnviando(false);
        }

        
    }

    const obtenerFormatoFirmado = async () => {
        const labelMotivo = jsonSelectedMotivoPrestamoValue?.label ?? "";
        const esOtroMotivo = labelMotivo === "Otros" || labelMotivo === "Otro";
        const motivoTexto = esOtroMotivo
            ? `Otros: ${jsonTextAreaOtros ?? ""}`
            : labelMotivo;
        const updatedFirmaColaboradorPayLoad = {
            IdTipoSolicitud: jsonSelectedTiposPrestamoValue?.Value,
            NroCuotas: formValues.NroCuotas,
            MesGratificacion: formValues.MesDsctoGratificacion,
            Motivo: motivoTexto,
            MontoSolicitado : formValues.Monto ? String(formValues.Monto) : "0",
            FileViewModel: s3UploadFileResponseFirma
        };
        const huellaGenerada = construirHuellaDocumento();
        const response = await executePostRequest(downloadSolicitudPrestamoAPI(), updatedFirmaColaboradorPayLoad);
        if (responseCode200(response)) {
            setDocumentoFirmado(response?.data?.Body ?? {});
            setHuellaDocumentoFirmado(huellaGenerada);
            return response?.data?.Body ?? null;
        } else {
            mostrarMensajeDeErrorConToast(response);
            setDocumentoFirmado({});
            setHuellaDocumentoFirmado("");
            return null;
        }
    }

    const handlePrevisualizar = async () => {
        if (!s3UploadFileResponseFirma?.Path) {
            toast.warn("Debe adjuntar una imagen de su firma.");
            return;
        }
        if (!checkFirma) {
            toast.warn("Debe aceptar el uso de su firma.");
            return;
        }
        const previewWindow = window.open('', '_blank');
        if (!previewWindow) {
            toast.warn("Permita ventanas emergentes para ver la vista previa.");
            return;
        }
        previewWindow.document.write('<p style="font-family:sans-serif;text-align:center;margin-top:40px;color:#666;">Generando documento...</p>');
        setPrevisualizando(true);
        try {
            const pdf = await obtenerFormatoFirmado();
            if (pdf?.UrlS3) {
                previewWindow.location.href = pdf.UrlS3;
                toast.success("Documento generado correctamente.");
            } else {
                previewWindow.close();
            }
        } catch {
            previewWindow.close();
        } finally {
            setPrevisualizando(false);
        }
    }

    return (
        <GenericModal titulo="Crear solicitud de Préstamo/Adelanto" showModal={showModal} width='900px'>
            <div className="modal-body">
                <form className="black-color-important">
                    
                    {fromAdminPage && esGestorPrestamos && (
                    <>
                    <hr/>
                    <div className="form-group row form-input-modal-contactanos">
                        <label className="col-sm-4 col-form-label modal-label">Buscar colaborador</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control modal-addPrestamo-input-buscador" placeholder='Nombre, Apellidos, DNI' name="datosColaborador" value={criterioDeBusqueda ?? ""}
                                           onChange={(e) => {
                                               setCriterioDeBusqueda(e.target.value);
                                           }}
                                           onKeyPress={handleKeypress}></input>
                            
                        </div>
                        <button
                                onClick={buscarColaborador}
                                type='button'
                                className='btn btn-primary generic-button-ficha-modal boton-buscar-generic-listar font-gothan-light'>
                                Buscar
                            </button>
                    </div>

                    <div className="form-group row form-input-modal-contactanos">
                        <label className="col-sm-4 col-form-label modal-label">Seleccionar Colaborador<span className="required">*</span></label>
                        <div className="col-sm-6 modal-prestamo-input-select-colaboradores-filtrados">
                            <SelectInput options={colaboradoresFiltradosOptions} jsonSelectedValue={jsonSelectedColaboradorValue} setJsonSelectedValue={setJsonSelectedColaboradorValue} isDisabled={false} placeholder={selectInputColaboresPlaceholder}/>
                            <p className="ficha-form-input-validation-message" id={`ficha-edit-${sectionName}-IdEmpleado-validation-message`}></p>
                        </div>
                        {cargandoColaboradores && (<><FontAwesomeIcon icon='spinner' transform="left-9" className="hand-pointer spinner modal-prestamo-input-select-spinner-cargando-colaboradores"/></>)}
                    </div>
                    <hr/>
                    </>
                    )}

                    <div className="displayFlexWrap">

                        {/* ── Tipo de Solicitud ── */}
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Tipo de Solicitud <span className="required">*</span>
                            </label>
                            <SelectInput options={tiposDePrestamoFiltradosOptions} 
                                jsonSelectedValue={jsonSelectedTiposPrestamoValue} 
                                //setJsonSelectedValue={setJsonSelectedTiposPrestamoValue} 
                                setJsonSelectedValue={(seleccionado) => {
                                    setJsonSelectedTiposPrestamoValue(seleccionado);
                                    setFormValues(prev => ({ 
                                        ...prev, 
                                        IdTipoSolicitud: seleccionado?.Value || seleccionado?.value || null 
                                    }));
                                }}
                                isDisabled={false}
                                
                                placeholder={"Seleccionar tipo de solicitud"} />
                                {Number(jsonSelectedTiposPrestamoValue?.Value) === ID_SOLICITUD_TIPO_ADELANTO_SUELDO && (
                                    <small className="text-danger">
                                        El adelanto se descontará del pago de haberes del mes donde se aprueba la solicitud.
                                    </small>
                                )}
                        </div>

                        {/* ── Monto ── */}
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Monto (S/.) <span className="required">*</span>
                            </label>
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                className="form-control"
                                placeholder="0.00"
                                value={formValues.Monto ?? ""}
                                onChange={e => setFormValues({...formValues, Monto: e.target.value})}
                            />
                        </div>

                        {/* ── Sueldo del colaborador ── */}
                        {sueldoEmpleado && (
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Sueldo del Colaborador
                            </label>
                            <input type="text" className="form-control"
                                value={`S/. ${parseFloat(sueldoEmpleado).toFixed(2)}`} disabled />
                        </div>
                        )}

                        {/* ── Número de Cuotas ── <div className="col-sm-12 col-md-6 mb-3"> */}
                        { TIPO_PRESTAMO_IDS_CUOTAS.includes(jsonSelectedTiposPrestamoValue?.Value ) ? (
                        <div className="col-sm-6">
                            <label className="modal-label">
                                Número de Cuotas <span className="required">*</span>
                            </label>
                            <select className="form-control col-sm-12"                                 
                                value={formValues.NroCuotas ?? ""} 
                                onChange={e => setFormValues({ ...formValues, NroCuotas: e.target.value })}
                                >
                                <option value="" disabled>Seleccione...</option>
                                {Array.from({ length: maxCuota }, (_, i) => i + 1).map(n => (
                                    <option key={n} value={n}>
                                        {n} 
                                    </option>
                                ))}
                            </select>
                            {parseFloat(formValues.Monto) > 0 && parseInt(formValues.NroCuotas) > 0 && (
                            <div className="mt-2">
                                <span className="text-muted">
                                    Valor de Cuota: S/. {(parseFloat(formValues.Monto) / parseInt(formValues.NroCuotas)).toFixed(2)}
                                </span>
                            </div>
                            )}
                        </div>
                        ) : null}

                        {/* ── Preview Mes de Descuento ── */}
                        {mesInicioDescuentoPreview && TIPO_PRESTAMO_IDS_CUOTAS.includes(jsonSelectedTiposPrestamoValue?.Value) ? (
                        <div className="col-sm-6">
                            <label className="modal-label">Mes de Inicio de Descuento</label>
                            <input type="text" className="form-control col-sm-12"
                                value={formatearMesPreview(mesInicioDescuentoPreview)} disabled />
                        </div>
                        ) : null}

                        {mesFinDescuentoPreview && TIPO_PRESTAMO_IDS_CUOTAS.includes(jsonSelectedTiposPrestamoValue?.Value) ? (
                        <div className="col-sm-6">
                            <label className="modal-label">Mes de Fin de Descuento</label>
                            <input type="text" className="form-control col-sm-12"
                                value={formatearMesPreview(mesFinDescuentoPreview)} disabled />
                        </div>
                        ) : null}


                        {/* ── Mes de Descuento de Gratificación ── */}
                        { TIPO_PRESTAMO_IDS_MESGRATI.includes(jsonSelectedTiposPrestamoValue?.Value) ? (
                        mesGratificacionPermitido ? (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Mes de Descuento de Gratificación <span className="required">*</span>
                            </label>
                            <input type="text" className="form-control col-sm-6"
                                value={mesGratificacionPermitido} disabled />
                        </div>
                        ) : (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Mes de Descuento de Gratificación <span className="required">*</span>
                            </label>
                            <select className="form-control col-sm-6"
                                value={formValues.MesDsctoGratificacion ?? ""}
                                onChange={e => setFormValues({ ...formValues, MesDsctoGratificacion: e.target.value })}>
                                <option value="" disabled>Seleccione...</option>
                                <option value="Julio">Julio</option>
                                <option value="Diciembre">Diciembre</option>
                            </select>
                        </div>
                        )
                        ) : null}

                        
                        {/* ── Motivo ── */}
                        { TIPO_PRESTAMO_IDS_MOTIVO.includes(jsonSelectedTiposPrestamoValue?.Value ) ? (
                        <>
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Motivo <span className="required">*</span>
                            </label>
                            <SelectInput options={motivosDePrestamoFiltradosOptions} 
                                        jsonSelectedValue={jsonSelectedMotivoPrestamoValue} 
                                        //setJsonSelectedValue={setJsonSelectedMotivoPrestamoValue} 
                                        setJsonSelectedValue={(seleccionado) => {
                                            setJsonSelectedMotivoPrestamoValue(seleccionado);
                                            setFormValues(prev => ({ 
                                                ...prev, 
                                                IdMotivoSolicitud: seleccionado?.Value || seleccionado?.value || null 
                                            }));
                                        }}
                                        isDisabled={false}
                                        placeholder={"Seleccionar motivo de préstamo"} />
                        </div>
                        {jsonSelectedMotivoPrestamoValue?.label === "Otros" ? (
                        <div className="col-sm-12 col-md-6 mb-3">
                            <textarea
                                className="form-control"
                                rows={3}
                                //onChange={(e) => setJsonTextAreaOtros(e.target.value)} 
                                onChange={(e) => {
                                    const valorDigitado = e.target.value;
                                    setJsonTextAreaOtros(valorDigitado);
                                    setFormValues(prev => ({ ...prev, OtroMotivo: valorDigitado }));
                                }}
                                value={jsonTextAreaOtros ?? ""}
                                placeholder="Describa el motivo de su solicitud..."
                            />
                        </div>
                        ) : null}
                        </>
                        ) : null}

                        {/* ── Otro Motivo ── */}
                        {/* <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Especifique el motivo <span className="required">*</span>
                            </label>
                            
                        </div> */}






                        {/* ── Archivo Adjunto ── */}
                        {/* <div className="col-sm-12 mb-3">
                            <label className="modal-label">Archivo Adjunto</label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2 
                                    uploadFileToS3={setS3UploadFileResponseFirma} 
                                    id={UPDATE_FILE_INPUT_ID} 
                                    textButton={"Subir imagen de tu firma"} 
                                    extensionesValidas={["jpg", "jpeg", "png"]} 
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoFirma} 
                                    setSubiendoArchivoPublicState={setSubiendoArchivoFirma}/>
                                <p className="ficha-form-input-validation-message" id={`ficha-edit-${sectionName}-FileViewModel-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: JPG y PNG (máx. 8MB)
                            </small>
                        </div> */}

                        {fromAdminPage && esGestorPrestamos ? (
                        <>
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Documento de Solicitud de Préstamo <span className="required"> *</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponseAutorizacion}
                                    id={UPDATE_FILE_AUTORIZACION_ID}
                                    textButton={"Subir solicitud de préstamo"}
                                    extensionesValidas={["pdf", "jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoAutorizacion}
                                    setSubiendoArchivoPublicState={setSubiendoArchivoAutorizacion}/>
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-Autorizacion-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: PDF, JPG, PNG (máx. 8MB)
                            </small>
                        </div>
                        {requiereSustento && (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Documento Sustento <span className="required"> *</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponseSustento}
                                    id={UPDATE_FILE_SUSTENTO_ID}
                                    textButton={"Subir documento sustento"}
                                    extensionesValidas={["pdf", "jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoSustento}
                                    setSubiendoArchivoPublicState={setSubiendoArchivoSustento}/>
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-Sustento-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: PDF, JPG, PNG (máx. 8MB)
                            </small>
                        </div>
                        )}
                        </>
                        ) : (
                        <>
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Imagen de Firma <span className="required"> *</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponseFirma}
                                    id={UPDATE_FILE_FIRMA_ID}
                                    textButton={"Subir imagen de tu firma"}
                                    extensionesValidas={["jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoFirma}
                                    setSubiendoArchivoPublicState={setSubiendoArchivoFirma}/>
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-Firma-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: JPG y PNG (máx. 8MB)
                            </small>
                        </div>
                        {requiereSustento && (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Documento Sustento <span className="required"> *</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponseSustento}
                                    id={UPDATE_FILE_SUSTENTO_ID}
                                    textButton={"Subir documento sustento"}
                                    extensionesValidas={["pdf", "jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoSustento}
                                    setSubiendoArchivoPublicState={setSubiendoArchivoSustento}/>
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-Sustento-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: PDF, JPG, PNG (máx. 8MB)
                            </small>
                        </div>
                        )}
                        </>
                        )}

                        {/* ── Checkboxes ── */}
                        <div className="col-sm-12 mt-2">
                            <div className="form-check mb-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="checkFirmaPreview"
                                    checked={checkFirma}
                                    onChange={e => setCheckFirma(e.target.checked)}
                                />
                                <label
                                    className="form-check-label ficha-declaracion-jurada-message"
                                    htmlFor="checkFirmaPreview"
                                >
                                    Mi firma será utilizada únicamente para esta solicitud
                                    y no será almacenada.
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="checkDeclaracionPreview"
                                    checked={checkDeclaracion}
                                    onChange={e => setCheckDeclaracion(e.target.checked)}
                                />

                                <label
                                    className="form-check-label ficha-declaracion-jurada-message"
                                    htmlFor="checkDeclaracionPreview"
                                >
                                    Declaración Jurada: Declaro bajo juramento que toda la
                                    información proporcionada es clara y verdadera.
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-0" />
                    <div className="col-sm-12 mt-2">
                        <InputBool
                            label="Esta solicitud ha sido previamente coordinada y aprobada por mi jefe directo."
                            colLabel={6}
                            colInput={4}
                            name="ComunicoAJefe"
                            value={formValues.ComunicoAJefe ?? false}
                            onChange={e => {
                                        const checked = e?.target?.checked ?? false;
                                        setFormValues(prev => ({
                                            ...prev,
                                            ComunicoAJefe: checked
                                        }))
                            }}
                            sectionName={sectionName}
                        />
                    </div>
                    {fromAdminPage && esGestorPrestamos && (
                    <div className="col-sm-12 mt-2">
                        <div className="form-row">
                            <div className="col-sm-12 col-md-6 mb-3">
                                <InputBool
                                    label="Excepción"
                                    name="TieneExcepcion"
                                    value={formValues.TieneExcepcion ?? false}
                                    onChange={e => {
                                        const checked = e?.target?.checked ?? false;
                                        setFormValues(prev => ({
                                            ...prev,
                                            TieneExcepcion: checked,
                                            MotivoExcepcion: checked ? prev.MotivoExcepcion : ""
                                        }));
                                    }}
                                    sectionName={sectionName}
                                />
                            </div>
                        </div>
                        {formValues.TieneExcepcion && (
                        <div className="form-row">
                            <div className="col-sm-12 mb-3">
                                <label className="modal-label">
                                    Detalle de la Excepción <span className="required">*</span>
                                </label>
                                <textarea className="form-control" rows={3}
                                    value={formValues.MotivoExcepcion ?? ""}
                                    onChange={e => {
                                        const value = e.target.value;
                                        setFormValues(prev => ({
                                            ...prev,
                                            MotivoExcepcion: value
                                        }));
                                    }}
                                    placeholder="Describa el detalle de la excepción..." />
                            </div>
                        </div>
                        )}
                    </div>
                    )}
                    {/* ── Footer ── */}
                    <div className="modal-footer pl-0">
                        <div className="d-flex justify-content-between w-100">
                            <div>
                                {!fromAdminPage && s3UploadFileResponseFirma?.Path && (
                                    <button type="button" className="btn btn-primary generic-button-ficha"
                                        onClick={handlePrevisualizar} disabled={previsualizando || enviando}>
                                        {previsualizando ? <><FontAwesomeIcon icon="spinner" className="spinner mr-1" /> Generando...</> : "Previsualizar Documento"}
                                    </button>
                                )}
                            </div>
                            <button type="button" className="btn generic-button-buscador" onClick={handleEnviarSolicitud} disabled={enviando || previsualizando}>
                                {enviando ? "Enviando..." : "Enviar"}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </GenericModal>
    );
};

export default SolicitarPrestamo;
